import { render, staticRenderFns } from "./DoctorCard.vue?vue&type=template&id=3c504bea&"
import script from "./DoctorCard.vue?vue&type=script&lang=ts&setup=true&"
export * from "./DoctorCard.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c504bea')) {
      api.createRecord('3c504bea', component.options)
    } else {
      api.reload('3c504bea', component.options)
    }
    module.hot.accept("./DoctorCard.vue?vue&type=template&id=3c504bea&", function () {
      api.rerender('3c504bea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/appointment/vrach/new/components/DoctorAppointmentForm/components/DoctorCard/DoctorCard.vue"
export default component.exports